import bookingSettings from "../services/booking.settings";
import organization from "../services/organization";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        settings: [],
        errors: null,
        branches: [],
        branchOptions: [],
        branchesWithRooms: []
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        branches(state, branches) {
            state.branches = branches;
            state.loading = false;
        },
        branchOptions(state, branchOptions) {
            state.branchOptions = branchOptions;
            state.loading = false;
        },
        branchesWithRooms(state, branchesWithRooms) {
            state.branchesWithRooms = branchesWithRooms;
            state.loading = false;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        settings(state, settings) {
            state.settings = settings;
        }
    },
    actions: {
        async getBranches({ commit }) {
            commit("loading");
            try {
                let response = await organization.getBranches();
                let result = await bookingSettings.viewSettings();
                commit("branches", response);
                commit("branchOptions", response.map(obj =>{ 
                    var rObj = {};
                    rObj["value"] = obj.uuid;
                    rObj["text"] = obj.name;
                    return rObj;
                }));
                if (!result.settings.rooms || result.settings.rooms.length === 0) {
                    result.settings.rooms = [];
                    let branchesWithRooms = [];
                    if (response.length > 0) {
                        branchesWithRooms.push({uuid: response[0].uuid, name: response[0].name});
                    }
                    commit("branchesWithRooms", branchesWithRooms);
                    
                } else {
                    let branchesUuids = [...new Set(result.settings.rooms.map(room => room.branch_uuid))];
                    let branchesWithRooms = [];
                    for (let index = 0; index < branchesUuids.length; index++) {
                        branchesWithRooms.push(response.filter(branch => branch.uuid === branchesUuids[index]).pop());
                    }
                    commit("branchesWithRooms", branchesWithRooms);
                    
                }
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveSettings({ commit }, param) {
            commit("loading");
            try {
                let response = await bookingSettings.saveSettings(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot save settings.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewSettings({ commit }) {
            commit("loading");
            try {
                let response = await bookingSettings.viewSettings();
                if (!response.settings.phrases || response.settings.phrases.length === 0) {
                    response.settings.phrases = [{uuid: "", name: ""}];
                }
                if (!response.settings.categories || response.settings.categories.length === 0) {
                    response.settings.categories = [{uuid: "", name: ""}];
                }
                commit("settings", response.settings);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        }
    }
};
